import { createContext, ReactNode, useContext, useMemo } from 'react';

export type InsightsPageContextType = {
  openFeedbackDialog: () => void;
  pageId: string;
  showSoftBlockBanner: boolean;
};

const InsightsPageContext = createContext<InsightsPageContextType>({
  openFeedbackDialog: () => {},
  pageId: '',
  showSoftBlockBanner: false,
});

type InsightsPageContextProviderProps = {
  children: ReactNode;
  openFeedbackDialog: () => void;
  pageId: string;
  showSoftBlockBanner: boolean;
};

export const InsightsPageContextProvider = ({
  children,
  openFeedbackDialog,
  pageId,
  showSoftBlockBanner,
}: InsightsPageContextProviderProps) => {
  const cx = useMemo(
    () => ({
      openFeedbackDialog,
      pageId,
      showSoftBlockBanner,
    }),
    [openFeedbackDialog, pageId, showSoftBlockBanner],
  );
  return <InsightsPageContext.Provider value={cx}>{children}</InsightsPageContext.Provider>;
};

export const useInsightsPageContext = () => useContext(InsightsPageContext);
